import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import parseISO from 'date-fns/parseISO';

import { useTheme } from "@mui/material";

import { DateRangePickerWrapperStyled } from 'shared/components/date-range-field/DateRange';

const DateInput = (props) => {
  const { id, type, typeName, name, order, input: { onChange, value }, dateFormat, locale, label, values } = props;
  const [date, setDate] = useState();
  const [attribute, setAttribute] = useState({ MIN: null, MAX: null });

  const { palette } = useTheme();
  const { primary: { contrastText, main, mainRGB } } = palette;

  useEffect(() => {
    let defaultValue;
    const newAttribute = { ...attribute };
    // console.log('values', values, value);

    if (values?.length > 0) {
      for (let i = 0; i < values.length; i++) {
        // if (!value && values[i].default) {
        // if (!date && values[i].default) {
        if (values[i].value && values[i].default) {
          defaultValue = parseISO(values[i].value);
          // console.log('values[i].value', values[i].value, 'date', date, 'value', value);
        }
        if (values[i].typeName === 'MIN') {
          newAttribute.MIN = parseISO(values[i].value);
        }
        if (values[i].typeName === 'MAX') {
          newAttribute.MAX = parseISO(values[i].value);
        }
      }
      // console.log('defaultValue', defaultValue);
      setAttribute(newAttribute);
    }

    if (defaultValue != null) {
      setDate(defaultValue);
      // onChange(defaultValue.toISOString()); 
      onChange({
        id,
        typeName,
        order,
        result: defaultValue.toISOString()
      });
    }
  }, []);

  const handleChange = (newValue) => {
    // console.log('handleChange', newValue)
    setDate(newValue);
    const inputValue = newValue ?
      {
        id,
        typeName,
        order,
        result: newValue?.toISOString()
      } :
      null;
    onChange(inputValue);
  }

  return (
    <DateRangePickerWrapperStyled main={main} mainRGB={mainRGB}>
      <DatePicker
        locale={locale}
        dateFormat={dateFormat}
        isClearable="true"
        showYearDropdown="true"
        dropdownMode="select" //"scroll"
        selected={date}
        onChange={handleChange}
        minDate={attribute.MIN ? new Date(attribute.MIN) : null}
        maxDate={attribute.MAX ? new Date(attribute.MAX) : null}
      />
    </DateRangePickerWrapperStyled>
  );
}

export default DateInput;